/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Network_Error_During_UploadInputs */

const en_api_error_network_error_during_upload = /** @type {(inputs: Api_Error_Network_Error_During_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Network error during upload.`)
};

const pt_br2_api_error_network_error_during_upload = /** @type {(inputs: Api_Error_Network_Error_During_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro de rede durante o upload.`)
};

/**
* | output |
* | --- |
* | "Network error during upload." |
*
* @param {Api_Error_Network_Error_During_UploadInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_network_error_during_upload = /** @type {((inputs?: Api_Error_Network_Error_During_UploadInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Network_Error_During_UploadInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_network_error_during_upload(inputs)
	return pt_br2_api_error_network_error_during_upload(inputs)
});